export default __webpack_public_path__ + "static/media/Charlie 9781846164606.77cc45f1.jpg";